import { SupportedTokenName } from "@mezo/sdk"
import { ParagraphSmall } from "@mezo-org/mezo-clay"

import CurrencySymbol from "#/shared/components/CurrencySymbol"
import TooltipLabel from "#/shared/components/TooltipLabel"
import {
  BITCOIN_MINIMUM_WITHDRAWABLE_AMOUNT,
  SDK_NETWORK,
} from "#/shared/constants"
import { getCurrencySymbol } from "#/shared/utils"

import { ReturnAssetButton } from "../Button"

type DepositReturnActionProps = {
  token: SupportedTokenName
  userAmount: string
  mintedAmount: bigint
  onReturnButtonClick: () => void
  onWithdrawalButtonClick: () => void
}

export default function DepositReturnAction({
  token,
  userAmount,
  mintedAmount,
  onReturnButtonClick,
  onWithdrawalButtonClick,
}: DepositReturnActionProps) {
  // Information for us when testing, to know that BTC deposit has not met
  // minimum threshold to be withdrawn
  const isTestnetBtcDepositWithdrawable =
    token === "BTC" && Number(userAmount) >= BITCOIN_MINIMUM_WITHDRAWABLE_AMOUNT

  const isTestnetDepositWithdrawable =
    token !== "BTC" || isTestnetBtcDepositWithdrawable

  const isWithdrawable =
    SDK_NETWORK === "mainnet" || isTestnetDepositWithdrawable

  const withdrawalActionContent = isWithdrawable ? (
    <ReturnAssetButton onClick={onWithdrawalButtonClick} />
  ) : (
    <TooltipLabel
      value={
        <ParagraphSmall>
          Minimum withdrawable <CurrencySymbol token="BTC" /> deposit <br />
          amount is {BITCOIN_MINIMUM_WITHDRAWABLE_AMOUNT}
        </ParagraphSmall>
      }
      variant="light"
      placement="top"
    >
      <ParagraphSmall>Not withdrawable</ParagraphSmall>
    </TooltipLabel>
  )

  return mintedAmount > 0n ? (
    <ReturnAssetButton
      onClick={onReturnButtonClick}
      content={`Return ${getCurrencySymbol("stBTC")}`}
    />
  ) : (
    withdrawalActionContent
  )
}
